import React, { memo, useCallback, useMemo } from 'react'

import { FiltersSidebar } from '@cgtrader/triangle-ui/dist/src/ssr-index'

import { FILTER_NAME } from 'Pods/SearchPage/Shared/Tracking/constants'
import { useTrackFilterSelect } from 'Pods/SearchPage/Shared/Tracking/FilterTracking'
import useTranslate from 'Pods/SearchPage/Shared/useTranslate'
import { toggleSubscriptionTier } from 'Pods/SearchPage/Store/actions/pricing'
import { SUBSCRIPTION_TIER } from 'Pods/SearchPage/Store/constants'
import { useSearchPageStore } from 'Pods/SearchPage/Store/index'
import usePageConfig from 'Pods/Shared/Hooks/usePageConfig'

import { EMPTY_ARRAY } from 'Utils/stableDefaults'

function SubscriptionTier() {
  const translate = useTranslate()
  const subscriberTier = usePageConfig()?.subscriptionTier

  const withSubscription = useSearchPageStore(state => state.withSubscription)
  const subscriptionTiers = useSearchPageStore(state => state.subscriptionTiers)
  const trackFilterSelect = useTrackFilterSelect()

  // A subscription search with no plan picked (an old "All" URL) spans every tier, which is what
  // Premium shows.
  const selectedFilters = useMemo(() => {
    if (!withSubscription) return EMPTY_ARRAY
    if (!subscriptionTiers?.length) return [SUBSCRIPTION_TIER.PREMIUM]

    return subscriptionTiers
  }, [withSubscription, subscriptionTiers])

  // Essentials/Premium are plan names, so they stay untranslated - same as the legacy listing.
  const filters = useMemo(() => {
    const planLabel = (tier, name) => {
      if (tier !== subscriberTier) return name

      return (
        <span className="price-filter__plan-label">
          {name}
          {' '}
          <span className="price-filter__your-plan cgt-overline-sm">
            {translate('search_page.filters.price.your_plan')}
          </span>
        </span>
      )
    }

    return [{
      label: translate('search_page.filters.price.with_subscription'),
      filters: [
        { value: SUBSCRIPTION_TIER.ESSENTIALS, label: planLabel(SUBSCRIPTION_TIER.ESSENTIALS, 'Essentials') },
        { value: SUBSCRIPTION_TIER.PREMIUM, label: planLabel(SUBSCRIPTION_TIER.PREMIUM, 'Premium') },
      ],
    }]
  }, [translate, subscriberTier])

  const handleFilterChange = useCallback((_, value, isOn) => {
    if (isOn) {
      trackFilterSelect(FILTER_NAME.PRICE, `subscription_tier_${value}`)
    }
    toggleSubscriptionTier(value, isOn)
  }, [trackFilterSelect])

  return (
    <div className="price-filter__subscription-tier">
      <FiltersSidebar
        isCollapsible={false}
        filters={filters}
        selectedFilters={selectedFilters}
        onFiltersChange={handleFilterChange}
        limit={0}
        isControlled
        useNewCheckboxes
        hideLastDivider
        hideShowMore
        baseFormWrapperClassName="filter-wrapper__content"
      />
    </div>
  )
}

export default memo(SubscriptionTier)
